module.exports = __webpack_public_path__ + "static/media/lend_usdj.51f5b1b1.svg";